import type { AccessKey, AccessType } from '@bb/domain/dist/types';

export const AccessTypeMap: Partial<
  Record<
    AccessType,
    {
      value: AccessType;
      label: string;
      codePlaceholder?: string;
      placeholder: string;
      // keys from appointment.appointmentConfig.instructions
      instructionsKey: AccessKey;
      codeKey?: 'code' | 'deviceId' | 'lbsn' | 'serialNumber';
    }
  >
> = {
  'Lock Box': {
    value: 'Lock Box',
    label: 'Lock Box',
    codePlaceholder: 'Lock box code',
    placeholder: 'Lock box instructions',
    instructionsKey: 'lockbox',
    codeKey: 'code',
  },
  Direct: {
    value: 'Direct',
    label: 'Direct',
    placeholder: 'Special access instructions',
    instructionsKey: 'direct',
  },
  Key: {
    value: 'Key',
    label: 'Key',
    placeholder: 'Key access instructions',
    instructionsKey: 'key',
  },
  'Door Code': {
    value: 'Door Code',
    label: 'Door Code',
    instructionsKey: 'doorcode',
    codePlaceholder: 'Door code',
    placeholder: 'Door code instructions',
    codeKey: 'code',
  },
  SentriLock: {
    value: 'SentriLock',
    label: 'SentriLock',
    instructionsKey: 'sentrilock',
    placeholder: 'Special access instructions',
    codeKey: 'lbsn',
  },
  SentriLockV2: {
    value: 'SentriLockV2',
    label: 'SentriLock',
    instructionsKey: 'sentrilockv2',
    placeholder: 'Special access instructions',
    codeKey: 'lbsn',
  },
  'SentriLock App': {
    value: 'SentriLock App',
    label: 'SentriLock App',
    instructionsKey: 'sentrilockapp',
    placeholder: 'Special access instructions',
  },
  'Supra eKEY': {
    value: 'Supra eKEY',
    label: 'Supra eKEY',
    instructionsKey: 'supraekey',
    placeholder: 'Special access instructions',
  },
  'Supra Lockbox': {
    value: 'Supra Lockbox',
    label: 'Supra',
    instructionsKey: 'supralockbox',
    placeholder: 'Special access instructions',
    codeKey: 'serialNumber',
  },
  MasterLock: {
    value: 'MasterLock',
    label: 'Master Lock',
    instructionsKey: 'masterlock',
    placeholder: 'Special access instructions',
    codeKey: 'deviceId',
  },
};
